import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters } = Filters;

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const AccessTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'accessType',
  label: 'accessLog.text.accessType',
  enumNamespace: getEnumNamespace(CoreEnums.UserAccessType),
  enumSource: CoreEnums.UserAccessType,
  options: createEnumOptions(CoreEnums.UserAccessType, 'accessLog.accessType', {
    casing: 'camel',
  }),
};

const OperationTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'operationType',
  label: 'accessLog.form.operationType',
  enumNamespace: getEnumNamespace(CoreEnums.UserAccessLogOperationType),
  enumSource: CoreEnums.UserAccessLogOperationType,
  options: createEnumOptions(CoreEnums.UserAccessLogOperationType, 'accessLog.operationType', {
    casing: 'camel',
  }),
};

const IsSuccessfulOperationFilter = {
  ...BaseFilters.BooleanFilter,
  name: 'isSuccessfulOperation',
  label: 'accessLog.text.isSuccessfulOperation',
};

const AppFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'appId',
  label: 'accessLog.text.app',
  labelInValue: true,
  displayField: 'name',
  apiRoute: 'app/allowed',
  params: {
    select: 'id,name',
    orderBy: 'name asc',
  },
  oDataField: 'appId',
};

const PortalFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'portalId',
  label: 'accessLog.text.portal',
  labelInValue: true,
  displayField: 'name',
  apiRoute: 'processportal/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
  oDataField: 'portalId',
};

export const filtersConfig = [
  CreatedDateFilter,
  AccessTypeFilter,
  OperationTypeFilter,
  IsSuccessfulOperationFilter,
  AppFilter,
  PortalFilter,
];

registerModuleFilters('accessLog', filtersConfig);
